import type PlayClient from '@empathybroker/tsclient-play'
import type { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import type { EndpointEnum } from '@empathybroker/tsclient-play/dist/enums/endpoint.enum'
import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { CrudDataTypeEnum } from '../../../enums'

import type { ActionClass, CrudState } from '../../../models'

import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'

import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'
import { FetchDataAction } from '../../../store/crud/actions/fetch-data.action'
import { CRUD_CONSTS } from '../../../store/crud/crud.consts'

export class DeleteAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<CrudState, any>,
    payload: { dataType: CrudDataTypeEnum; ids: string[] },
  ): Promise<any[]> {
    commit(CRUD_CONSTS.mutations.setState, {
      dataType: payload.dataType,
    })

    const serviceClient = FetchDataAction.getServiceClient(payload.dataType)
    const authToken = await CONTAINER.get<AccessTokenProvider>(TYPES.AccessTokenProvider)()
    return new Promise((resolve, reject) => {
      Promise.all(
        DeleteAction.getServiceRequests(payload.dataType, serviceClient, authToken, payload.ids),
      )
        .then(async (responses: any[]) => {
          const data = state.data.filter(dataItem => !payload.ids.includes(dataItem.id as string))
          commit(CRUD_CONSTS.mutations.setState, {
            data,
            pagination: {
              ...state.pagination,
              totalItems: data.length,
            },
          })
          await dispatch(`${CRUD_CONSTS.actions.tag}`, {
            featureId: payload.dataType,
            type: EngagementActionsTypeEnum.DELETE,
          })
          resolve(responses)
        })
        .catch(reject)
    })
  }

  private static getServiceRequests(
    dataType: CrudDataTypeEnum,
    serviceClient: PlayClient,
    authToken: string,
    ids: string[],
  ): Promise<any>[] {
    const endpoint: EndpointEnum = FetchDataAction.getPlayEndpointFromDomain()
    return ids.map((id: string) =>
      (serviceClient as PlayClient).delete(authToken, dataType as ActionTypeEnum, id, endpoint),
    )
  }
}
